export default {
  additionalFields: 'Нэмэлт талбарууд',
  basic: 'Үндсэн',
  advanced: 'Нарийвчилсан',
  mobileApp: 'Мобайл апп',
  print: 'Хэвлэх',
  printProps: {
    printOrientation: {
      label: 'Хуудасны чиглэл',
      info: 'Энэ объект өөрийн хэвлэх хэсгийг эхлүүлэхэд ашиглагдах чиглэл. Анхдагчаар экспортод сонгосон баримтын чиглэлийг дагана.',
    },
    orientations: {
      default: 'Анхдагч (баримт)',
      portrait: 'Босоо',
      landscape: 'Хэвтээ',
    },
  },
  validations: 'Баталгаажуулалтууд',
  function: 'Функц',
  editingFunction: 'Функц {{functionName}}-г засах',
  editorHelp: {
    json: 'Хүчинтэй илэрхийлэл нь Javascript-ийн дэд олонлог юм.',
    sql: 'Зөвхөн хүчинтэй SQL илэрхийллийг зөвшөөрнө.',
  },
  editorCompletionHelp: '- Боломжтой хувьсагчид болон ашиглаж болох функцуудыг харуулах',
  functionDescriptions: {
    categoryItemProp: 'Заасан кодтой ангиллын элементийн заасан $t(extraProp.label)-ийн утгыг буцаана',
    dateTimeDiff: '2 огноо-цагийн хоорондох ялгааг (минутаар) буцаана',
    distance: 'Заасан координатуудын хоорондох зайг (метрээр) буцаана',
    geoCoordinateAtDistance: 'Заасан координатаас тодорхой зай болон чиглэлд байрлах координатыг буцаана',
    geoDistance: '$t(nodeDefEdit:functionDescriptions.distance)',
    first: 'Заасан олон шинж чанар эсвэл объектын эхний утга эсвэл зангилааг буцаана',
    geoPolygon: 'Координатуудын жагсаалтаас GeoJSON-д олон өнцөгт үүсгэнэ',
    includes: 'Заасан олон шинж чанар заасан утгыг агуулсан бол үнэн буцаана.',
    index: 'Заасан зангилааны ах дүүсийнх нь доторх индексийг буцаана',
    isEmpty: 'Хэрэв аргумент утгагүй бол үнэн буцаана',
    isNotEmpty: 'Хэрэв аргумент ямар нэгэн утгатай бол үнэн буцаана',
    last: 'Заасан олон шинж чанар эсвэл объектын сүүлийн утга эсвэл зангилааг буцаана',
    ln: 'X-ийн натурал логарифмыг буцаана',
    log10: 'X-ийн 10-н суурьтай логарифмыг буцаана',
    max: 'Аргументуудын хамгийн их утгыг буцаана',
    min: 'Аргументуудын хамгийн бага утгыг буцаана',
    now: 'Одоогийн огноо эсвэл цагийг буцаана',
    parent: 'Заасан зангилааны эцэг объектыг буцаана',
    pow: 'Суурийн утгыг зэрэгт өргөсөн утгыг буцаана',
    prevCycleNote:
      'Зөвхөн Arena Mobile-д ажилладаг, олон мөчлөг тодорхойлогдсон бөгөөд өмнөх мөчлөгтэй холбоос идэвхжүүлсэн үед',
    prevCycleValue:
      'Өмнөх мөчлөгийн бичлэгт ижил шинж чанарын утгыг буцаана. $t(nodeDefEdit:functionDescriptions.prevCycleNote)',
    prevCycleValues:
      'Өмнөх мөчлөгийн бичлэгт ижил шинж чанаруудын утгуудыг буцаана. $t(nodeDefEdit:functionDescriptions.prevCycleNote)',
    recordCycle: 'Одоогийн бичлэгийн мөчлөгийг буцаана',
    recordDateCreated:
      'Одоогийн бичлэгийн үүсгэсэн огноо, цагийг datetime утгаар буцаана. Үүнийг текст, огноо эсвэл цагийн шинж чанарт ашиглаж болно',
    recordDateLastModified:
      'Одоогийн бичлэгийн сүүлд өөрчилсөн огноо, цагийг datetime утгаар буцаана. Үүнийг текст, огноо эсвэл цагийн шинж чанарт ашиглаж болно',
    recordOwnerEmail: 'Бичлэгийг эзэмшигч хэрэглэгчийн имэйлийг буцаана',
    recordOwnerName: 'Бичлэгийг эзэмшигч хэрэглэгчийн нэрийг буцаана',
    recordOwnerRole: 'Бичлэгийг эзэмшигч хэрэглэгчийн үүргийг (одоогийн судалгаанд) буцаана',
    rowIndex: 'Одоогийн хүснэгтийн мөрний (эсвэл маягтын) индексыг буцаана',
    taxonProp: 'Заасан кодтой таксоны заасан $t(extraProp.label)-ийн утгыг буцаана',
    taxonVernacularName: 'Заасан кодтой таксоны заасан хэлээрх (эхний) нутгийн нэрийг буцаана',
    unique: 'Олон шинж чанар эсвэл объектын өвөрмөц утгуудыг буцаана',
    userEmail: 'Нэвтэрсэн хэрэглэгчийн имэйлийг буцаана',
    userIsRecordOwner:
      'Бичлэгийг засаж буй хэрэглэгч нь мөн түүний эзэмшигч бол "үнэн", үгүй бол "худал" гэсэн боол утгыг буцаана',
    userName: 'Нэвтэрсэн хэрэглэгчийн нэрийг буцаана',
    userProp: 'Нэвтэрсэн хэрэглэгчийн заасан $t(extraProp.label)-ийн утгыг буцаана',
    uuid: 'UUID (бүх нийтийн өвөрмөц танигч)-г үүсгэнэ, үүнийг танигч болгон ашиглаж болно (жишээ нь, объектын түлхүүр шинж чанар болгон)',
    // SQL functions
    avg: 'Тоон хувьсагчийн дундаж утгыг буцаана',
    count: 'Заасан шалгуурт тохирох мөрүүдийн тоог буцаана',
    sum: 'Тоон хувьсагчийн нийт нийлбэрийг буцаана',
  },
  functionName: {
    rowIndex: 'Мөрийн индекс',
  },
  basicProps: {
    analysis: 'Шинжилгээ',
    autoIncrementalKey: {
      label: 'Автомат өсөн нэмэгдэх түлхүүр',
      info: 'Утга автоматаар үүсгэгдэнэ',
    },
    autoCreateMinCountItems: {
      label: 'Хамгийн бага элементийг автоматаар үүсгэх',
      info: 'Объект хэрэгжиж эхлэх үед эсвэл түүний эцэг объект үүсгэгдэх үед хамгийн бага тооны объектууд автоматаар үүсгэгдэнэ.',
    },
    displayAs: 'Илэрхийлэх',
    displayIn: 'Илэрхийлэхдээ',
    entitySource: 'Объектын эх үүсвэр',
    enumerate: {
      label: 'Тоолох',
      info: `Мөрүүд нь объектын дотор тодорхойлогдсон Түлхүүр гэж тэмдэглэгдсэн кодын шинж чанартай холбоотой ангиллын элементүүдийг ашиглан автоматаар үүсгэгдэнэ; мөр нэмэх эсвэл устгах боломжгүй бөгөөд түлхүүр кодын шинж чанарыг засах боломжгүй`,
    },
    enumeratingItemsExpression: {
      label: 'Тоочих элементүүдийн илэрхийлэл',
      info: 'Ангиллын аль элементүүдийг тоочихыг шүүх нэмэлт илэрхийлэл (жишээ нь unique(table_source.source_type)). Хоосон үед ангиллын бүх элементийг ашиглана.',
    },
    enumerator: {
      label: 'Тоологч',
      info: 'Ангиллын элементүүд эцэг объектын мөрүүдийг үүсгэхэд ашиглагдана',
    },
    form: 'Маягт',
    formula: 'Томьёо',
    includedInClonedData: 'Хувилах өгөгдөлд оруулсан',
    includedInMultipleEntitySummary: {
      label: 'Олон объектын хураангуйд оруулах',
      info: `Хэрэв тэмдэглэгдсэн бол шинж чанарын утга объект сонгогч болон объектын хураангуй харагдацад харагдана`,
    },
    includedInRecordsList: {
      label: 'Бүртгэлийн жагсаалтад оруулах',
      info: `Хэрэв тэмдэглэсэн бол уг шинж чанар нь бүртгэлийн жагсаалтад харагдах болно`,
    },
    key: 'Түлхүүр',
    maxKeysCountReached: 'Түлхүүрийн дээд тоо хүрсэн ({{maxKeysCount}})',
    multiple: 'Олон',
    ownPage: 'Өөрийн хуудас',
    parentPage: 'Эцэг хуудас ({{parentPage}})',
    qualifier: {
      label: 'Тодорхойлогч',
      info: `Бүлэгт харьяалагддаг хэрэглэгч шинэ бичлэг үүсгэхэд энэ атрибут нь хэрэглэгчийн бүлгийн тодорхойлогчид заасан утгаар автоматаар бөглөгдөнө. Хэрэглэгчид зөвхөн өөрийн бүлэгт хамаарах бичлэгүүдийг харах, засах боломжтой байх болно, хэрэв тэд бүлэгт харьяалагддаг бол.`,
    },
    table: 'Хүснэгт',
  },
  advancedProps: {
    defaultValuesNotSpecified: 'Үндсэн утгууд тодорхойлогдоогүй',
    defaultValuesSpecified: 'Үндсэн утгууд тодорхойлогдсон',
    editableAlways: 'Үргэлж засварлах боломжтой',
    editableIfConditionIsMet: 'Нөхцөл биелсэн үед засварлах боломжтой',
    relevantIfRadioNone: 'Үргэлж хамааралтай',
    relevantIfRadioDefined: 'Нөхцөл биелсэн үед хамааралтай',
    visibleAlways: 'Үргэлж харагдах',
    visibleIfConditionIsMet: 'Нөхцөл биелсэн үед харагдах',
    areaBasedEstimate: 'Талбай дээр суурилсан тооцоо',
    defaultValues: 'Үндсэн утгууд',
    defaultValuesInfo: `Энэ нь тодорхой дүрмийн дагуу хариуг автоматаар бөглөх боломжийг олгоно.
    Хэрэв хэд хэдэн дүрэм тохируулсан бол систем тэдгээрийг дээрээс доош дарааллаар шалгана.
    Нөхцөлд нийцсэн эхний дүрмийг хэрэглэж, түүний үр дүнг хариу болгон ашиглана.`,
    defaultValueEvaluatedOneTime: 'Үндсэн утга нэг удаа үнэлэгдсэн',
    defaultValueEvaluatedOneTimeInfo: `Шинж чанар үүсэх үед үндсэн утгыг зөвхөн нэг удаа үнэлнэ.
    Хэрэв тэмдэглээгүй бол бичлэг шинэчлэх бүрт үндсэн утгыг дахин үнэлнэ.
    now() эсвэл uuid() зэрэг зөвхөн нэг удаа үнэлэгдэх ёстой илэрхийллүүдийг ашиглах үед үүнийг тэмдэглэх хэрэгтэй.`,
    defaultValuesNotEditableForAutoIncrementalKey:
      'Автоматаар өсөн нэмэгдэх түлхүүр тохируулагдсан тул үндсэн утгуудыг засах боломжгүй',
    editableIf: 'Хэрэв засварлах боломжтой бол',
    editableIfInfo: `Анхдагчаар хэрэглэгч хамааралтай талбарт үргэлж хандах боломжтой.
Энд хэрэглэгч энэ талбарт бичих эсвэл утгыг өөрчлөх эсэхийг тодорхойлох дүрэм тохируулж болно.
Энэ нь хэрэглэгч энэ талбарт бичих эсвэл утгыг өөрчлөх боломжтой эсэхийг шийднэ.
    Хэрэв таны тохируулсан нөхцөл биелбэл талбарыг засварлаж болно. Үгүй бол зөвхөн унших (түгжигдсэн) болно.`,
    hidden: 'Үргэлж нуух',
    hiddenInReport: 'Аналитик хяналтын самбарт нуух',
    hiddenInReportInfo: `Хэрэв тэмдэглэгдсэн бол шинж чанар Аналитик хяналтын самбарт харагдахгүй`,
    hiddenWhenNotRelevant: 'Хамааралгүй үед нуух',
    itemsFilter: 'Элементүүдийн шүүлтүүр',
    itemsFilterInfo: `Сонгогдох элементүүдийг шүүхэд ашиглагдах илэрхийлэл.
Илэрхийлэлд "this" гэдэг үг нь элементийг өөрийг нь заана.
Жишээ нь: this.region = region_attribute_name
(энд "region" нь элементийн хувьд тодорхойлогдсон нэмэлт шинж чанарын нэр, region_attribute_name нь судалгаан дахь шинж чанарын нэр юм)`,
    readOnly: 'Зөвхөн унших',
    relevantIf: 'Хэрэв хамааралтай бол',
    relevantIfInfo: `Анхдагчаар бүх талбар идэвхтэй байна.
    Хэрэв хамааралтын дүрэм тохируулж, тэр нь биелэхгүй бол талбар саарал болох эсвэл бүрэн нуугдана,
    мөн автомат хариунуудыг үл тоомсорлоно.
    Үүнийг маягтын хэсгийг динамикаар харуулах/нуухад ашиглана; жишээ нь хэрэглэгч "Бусад" сонгосон үед л "Тодруулна уу" талбарыг харуулах.`,
    script: 'Скрипт',
    visibleIf: 'Хэрэв харагдах бол',
    visibleIfInfo: `Анхдагчаар талбар үргэлж харагдана.
    Хэрэв дүрэм тохируулбал, тэр дүрэм биелсэн үед л харагдана; эс тэгвээс нуугдана.
    Тэмдэглэл: "хамааралгүй" талбарыг нуухаас ялгаатай нь, нуугдсан талбар автомат хариуг хадгалж болно.
    Энэ нь хэн нэвтэрснээс (жишээ нь үүргээс) хамаарч маягтын бүхэл хэсгийг нуухад тохиромжтой.`,
  },
  mobileAppProps: {
    hiddenInMobile: {
      label: 'Арена Мобайл-д нуугдсан',
      info: `Хэрэв тэмдэглэгдсэн бол шинж чанар AM-д харагдахгүй`,
    },
    includedInPreviousCycleLink: {
      label: 'Өмнөх мөчлөгийн холбоосонд оруулах',
      info: `Хэрэв тэмдэглэгдсэн бол өмнөх мөчлөгийн утга өгөгдөл оруулах маягт дээр харагдана (мобайл апп-д өмнөх мөчлөгт холбоос идэвхтэй үед)"`,
    },
  },
  numericProps: {
    unit: 'Нэгж',
  },
  decimalProps: {
    maxNumberDecimalDigits: 'Бутархай тооны хамгийн их орон',
  },
  fileProps: {
    fileNameExpression: 'Файлын нэрийн илэрхийлэл',
    fileType: 'Файлын төрөл',
    fileTypes: {
      image: 'Зураг',
      video: 'Видео',
      audio: 'Аудио',
      other: 'Бусад',
    },
    maxFileSize: 'Хамгийн их файлын хэмжээ (МБ)',
    numberOfFiles: 'Хамгийн бага болон хамгийн их файлын тоог өөрчлөхийн тулд Баталгаажуулалт руу орно уу.',
    showGeotagInformation: 'Газарзүйн мэдээллийг харуулах',
  },
  mobileProps: {
    title: 'Мобайл апп',
  },
  timeProps: {
    includeSeconds: 'Секунд оруулах',
  },
  formHeaderProps: {
    headerColorLabel: 'Толгой хэсгийн өнгө',
    headerColor: {
      blue: 'Цэнхэр',
      green: 'Ногоон',
      orange: 'Улбар шар',
      red: 'Улаан',
      yellow: 'Шар',
    },
  },
  textProps: {
    displayAsTypes: {
      hyperlink: 'Гиперлинк',
      markdown: 'Markdown',
      text: 'Текст',
    },
    textInputType: 'Текстийн оролтын төрөл',
    textInputTypes: {
      singleLine: 'Нэг мөр',
      multiLine: 'Олон мөр',
    },
    textTransform: 'Текстийн хувиргалт',
    textTransformTypes: {
      none: 'байхгүй',
      capitalize: 'том үсгээр эхлэх',
      uppercase: 'том үсгээр',
      lowercase: 'бага үсгээр',
    },
  },
  booleanProps: {
    labelValue: 'Шошгын утга',
    labelValues: {
      trueFalse: '$t(common.true)/$t(common.false)',
      yesNo: '$t(common.yes)/$t(common.no)',
    },
  },
  codeProps: {
    category: 'Ангилал',
    codeShown: 'Кодыг харуулах',
    displayAsTypes: {
      checkbox: 'Чекбокс',
      dropdown: 'Дропдаун',
    },
    parentCode: 'Эх код',
  },
  coordinateProps: {
    allowOnlyDeviceCoordinate: 'Зөвхөн төхөөрөмжийн координатыг зөвшөөрөх',
    allowOnlyDeviceCoordinateInfo: `Зөвхөн Арена Мобайл-д хамаарна: хэрэв шалгагдсан бол хэрэглэгч X/Y утгуудыг өөрчлөх боломжгүй, зөвхөн төхөөрөмжийн GPS-г ашиглан тэдгээрийг авах боломжтой`,
    mapMarkerColor: 'Газрын зураг дээрх тэмдэглэгээний өнгө',
  },
  expressionsProp: {
    expression: 'Илэрхийлэл',
    applyIf: 'Хэрэв хэрэглэх бол',
    confirmDelete: 'Энэ илэрхийллийг устгах уу?',
    severity: 'Хүндрэл',
  },
  validationsProps: {
    minCount: 'Хамгийн бага тоо',
    maxCount: 'Хамгийн их тоо',
    expressions: 'Баталгаажуулалтын илэрхийлэл',
    attributeAlwaysValid: 'Шинж чанар үргэлж хүчинтэй',
    attributeValidWhenConditionIsMet: 'Нөхцөл биелсэн үед шинж чанар хүчинтэй',
  },
  cannotChangeIntoMultipleWithDefaultValues: 'Энэ зангилааг үндсэн утгуудтай олон болгох боломжгүй.',
  cannotDeleteNodeDefReferenced: `Зангилааны тодорхойлолт "{{nodeDef}}"-г устгах боломжгүй: энэ нь дараах зангилааны тодорхойлолтуудаар холбогдсон байна: {{nodeDefDependents}}`,
  cloneDialog: {
    confirmButtonLabel: 'Хувилах',
    title: 'Зангилааны тодорхойлолт "{{nodeDefName}}"-г хувилах',
    entitySelectLabel: 'Хувилах объект:',
  },
  conversion: {
    dialogTitle: '{{nodeDefName}}-г өөр төрөл болгон хөрвүүлэх',
    fromType: 'Эхний төрөл',
    toType: 'Хүртэлх төрөл',
  },
  moveDialog: {
    confirmButtonLabel: 'Шилжүүлэх',
    title: '"{{parentNodeDefName}}" -аас "{{nodeDefName}}" зангилааны тодорхойлолтыг зөөж байна',
    entitySelectLabel: 'Шилжүүлэх объект:',
  },
  movedNodeDefinitionHasErrors: 'Таны шилжүүлсэн зангилааны тодорхойлолт "{{nodeDefName}}" алдаатай байна; засна уу.',
  nodeDefintionsHaveErrors: 'Эдгээр зангилааны тодорхойлолтууд алдаатай байна: {{nodeDefNames}}. Засна уу.',
  filterVariable: 'Элементүүдийг шүүх хувьсагч',
  filterVariableForLevel: 'Түвшин {{levelName}}-д зориулсан хувьсагч',
  unique: {
    label: 'Өвөрмөц',
    info: `Шинж чанарыг **Өвөрмөц** гэж тэмдэглэсэн үед түүний утга нь хамгийн ойрын олон объектын дотор өвөрмөц байх ёстой (эсрэгээр нь алдаа гарна).

---

Жишээ нь, *бүлэглэл -> талбай -> мод* гэсэн бүтэцтэй бол, хэрэв танд **Өвөрмөц** гэж тэмдэглэгдсэн *tree_species* гэсэн шинж чанар байвал, нэг *талбай* дотор зөвхөн нэг төрлийн мод байж болно.`,
  },
  nodeDefClonedSuccessfully:
    'Зангилааны тодорхойлолт "{{nodeDefName}}"-г "{{targetParentNodeDefName}}" руу амжилттай хувиллаа',
  categoriesClonedFromSurvey: 'Дараах ангилалууд эх судалгаанаас мөн хувилагдсан: {{names}}',
  taxonomiesClonedFromSurvey: 'Дараах таксономууд эх судалгаанаас мөн хувилагдсан: {{names}}',
}
